export default "__VITE_ASSET__YY9gVfES__"